/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";
import { Block } from "src/classes/block";
import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";
import { BaseUser } from "src/classes/user";
import { DrilledButtons } from "src/components/Block/DrilledButtons";
import { Actions } from "src/components/DrilledView/SidePanel/Sections/Actions";
import { BlockAttributes } from "src/components/DrilledView/SidePanel/Sections/Attributes";
import { RelatedPages } from "src/components/DrilledView/SidePanel/Sections/RelatedPages";
import { SidePanelSection } from "src/components/DrilledView/SidePanel/Sections/SidePanelSection";

interface Props {
  block: Block;
  owner: BaseUser;
  likedBy: BaseUser[];
  plates: BasePlate[];
}
// side panel of drilled view
export function SidePanel({ block, owner, likedBy, plates }: Props) {
  return (
    <StyledSidePanel onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <SidePanelSection title="<attributes>">
        <BlockAttributes block={block} blockOwner={owner} likedBy={likedBy} />
      </SidePanelSection>
      <SidePanelSection title="">
        <DrilledButtons block={block} />
      </SidePanelSection>
      <SidePanelSection title="<plates>">
        <RelatedPages plates={plates} />
      </SidePanelSection>
      <SidePanelSection title="<actions>">
        <Actions block={block} />
      </SidePanelSection>
    </StyledSidePanel>
  );
}

const StyledSidePanel = styled.div`
  width: 300px;
  flex-shrink: 0;
  height: 100%;
  background-color: ${({ theme }) => theme.background};
  padding: 25px;
  font-family: "IBM Plex Mono";
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.text.default};
  overflow-y: auto;
  box-shadow: 10px 10px #e1e1e1;
  box-shadow: ${({ theme }) => `10px 10px ${theme.subtleContrast}`};
  margin-left: 20px;
  border: ${({ theme }) => `1px solid ${theme.primary}`};
  @media (max-width: ${DEVICE.small}) {
    height: unset;
    width: 90%;
    margin-bottom: 50px;
    margin-left: 0px;
  }
`;
